var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MyTransition',{attrs:{"myName":'opacity'}},[(_vm.laodingShow)?_c('div',{staticClass:"loading"},[_c('div',{class:['loading_bg',_vm.size]},[_c('Div',{staticClass:"text"},[_c('Div',{staticClass:"icon"},[_c('p')]),_vm._v(" Loading ")],1)],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }